export enum DdkState {
    NotApplicable = 'NotApplicable',
    NotProcessed = 'NotProcessed',
    Processed = 'Processed',
}
